import HelveticaFont from '../fonts/Helvetica.ttc';
import HelveticaNeue from '../fonts/HelveticaNeue.ttc';

const listTableStyle = (theme) => ({
  "@import url('https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i')": true,
  '@font-face': [
    {
      fontFamily: '"Helvetica, sans-serif"',
      src:
        `url(${HelveticaFont}) format("ttc"),\n       url(${HelveticaFont}) format("ttc")`,
    },
    {
      fontFamily: '"HelveticaNeue"',
      src:
        `url(${HelveticaNeue}) format("ttc"),\n       url(${HelveticaNeue}) format("ttc")`,
    },
  ],
  StepFormroot: {
    backgroundColor: '#fff',
    zIndex: 1,
    color: '#333',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: '600',
    fontSize: '22px',
    boxShadow: theme.palette.formPage.stepFormShadow,

  },
  StepFormlabelContainer: {
    '& $alternativeLabel': {
      marginTop: 0,
    },
  },
  StepFormactive: {
    color: '#fff',
    backgroundColor:
        '#09af58',
  },
  StepFormCompleted: {
    color: '#fff',
    backgroundColor:
        '#09af58',
  },
  body: {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '24px',
    color: '#757575',
    background: theme.palette.formPage.backgroundImage,
    //   background: "url('../images/backbg.png') 12% 20%",
    backgroundRepeat: 'repeat-y',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    minHeight: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    '& #msform': { textAlign: 'center', position: 'relative', marginTop: '10px' },
    '& .MuiSelect-icon': {
      display: 'none',
    },
    '& #msform input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill': {
      WebkitTextFillColor: theme.palette.formPage.color,
    },
    '& #msform fieldset': {
      background: theme.palette.formPage.backgroundColor,
      border: '0 none',
      borderRadius: '12px',
      padding: '20px 30px',
      boxSizing: 'border-box',
      width: '100%',
      boxShadow: theme.palette.formPage.fieldShadow,
      position: 'relative',

    },
    '@media (max-width:550px)': {
      '& #msform fieldset .form': {

        paddingBottom: '11px',
      },
      '& #msform fieldset .form, #msform .MuiFormControl-root label': {
        fontSize: '12px',
      },
      '& #msform fieldset': { padding: '15px 15px' },
    },
    '@media (max-width:315px)': {
      '& #msform fieldset .form, #msform .MuiFormControl-root label': {
        fontSize: '10px',
      },
    },

    '& .header-logo': {
      width: '260px',
      background: theme.palette.formPage.logo,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundAttachment: 'unset',
      height: '80px',
    },
    '& #msform fieldset:not(:first-of-type)': { display: 'none' },
    '& #msform .action-button': {
      width: '100px',
      background: '#0aaf58',
      fontWeight: 'bold',
      color: 'white',
      border: '0 none',
      borderRadius: '25px',
      cursor: 'pointer',
      padding: '12px 22px',
      margin: '10px 5px',
      fontSize: '14px',
      transition: '0.7s',
    },
    '& #msform .action-button:hover, #msform .action-button:focus': {
      boxShadow: '0 0 0 0px white, 0 0 0 3px #0aaf58',
      color: theme.palette.formPage.modalCol,
      transition: '0.7s',
      background: 'transparent',
    },

    '& #msform .action-button-previous': {
      width: '100px',
      background: 'transparent',
      fontWeight: 'bold',
      color: theme.palette.formPage.color,
      border: `${theme.palette.formPage.prevBorderWidth} solid ${theme.palette.formPage.prevBorderColor}`,
      borderRadius: '25px',
      cursor: 'pointer',
      transition: '0.7s',
      padding: '10px 5px',
      margin: '10px 5px',
    },
    '& #msform .action-button-previous:hover, #msform .action-button-previous:focus': {
      boxShadow: '0 0 0 2px white, 0 0 0 3px #C5C5F1',
      transition: '0.7s',
      background: 'transparent',
    },
    '& .fs-title': {
      fontSize: '18px',
      textTransform: 'uppercase',
      color: theme.palette.formPage.color,
      fontFamily: 'Helvetica, sans-serif',
      marginBottom: '10px',
      fontWeight: 'bold',
    },
    '& .fs-subtitle': {
      fontWeight: 'normal',
      fontSize: '13px',
      color: '#666',
      marginBottom: '20px',
    },
    '& #progressbar': {
      marginBottom: '14px',
      overflow: 'hidden',
      counterReset: 'step',
      paddingTop: '14px',
    },
    '& #progressbar li': {
      listStyleType: 'none',
      color: 'white',
      textTransform: 'uppercase',
      fontSize: '13px',
      fontWeight: 500,
      width: '33%',
      fontFamily: 'Helvetica, sans-serif',
      cssFloat: 'left',
      position: 'relative',
      letterSpacing: '0.5px',
    },
    '& #progressbar li:before': {
      content: 'counter(step)',
      counterIncrement: 'step',
      width: '55px',
      height: '55px',
      lineHeight: '55px',
      display: 'block',
      fontSize: '22px',
      fontFamily: 'Helvetica, sans-serif',
      color: '#333',
      fontWeight: 600,
      background: 'white',
      borderRadius: '50%',
      margin: '0 auto 10px auto',
      boxShadow: '0px 0px 0px 8px rgba(0, 0, 0, 0.33)',
    },
    '& #progressbar li:after': {
      content: "''",
      width: '100%',
      height: '1px',
      background: 'white',
      position: 'absolute',
      left: '-50%',
      top: '26px',
      zIndex: -1,
    },
    '& #progressbar li:first-child:after': { content: 'none' },
    '& #progressbar li.active:before, #progressbar li.active:after': {
      background: '#09af58',
      color: 'white',
    },
    '& .dme_link': { marginTop: '30px', textAlign: 'center' },
    '& .dme_link a': {
      background: '#FFF',
      fontWeight: 'bold',
      color: '#ee0979',
      border: '0 none',
      borderRadius: '25px',
      cursor: 'pointer',
      padding: '5px 25px',
      fontSize: '12px',
    },
    '& .dme_link a:hover, .dme_link a:focus': {
      background: '#C5C5F1',
      textDecoration: 'none',
    },

    '& .mb15': {
      marginBottom: '15px !important',
    },
    '& .themeBtn': {
      position: 'absolute',
      top: '25px',
      right: '30px',
      borderRadius: '50px',
      width: '20px',
      minWidth: '36px !important',
    },

    '& .listblock': {
      background: theme.palette.formPage.backgroundColorInput,
      boxShadow: theme.palette.formPage.blockShadow,
      padding: '11px 15px 11px 20px',
      textAlign: 'left',
      display: 'flex',
      borderBottom: '1px dashed #4c4d56',
      alignItems: 'center',
    },
    '& .listblock .icon': { padding: '0px', margin: '0px' },
    '& .pl14': {
      paddingLeft: '14px !important',
    },
    '& .listblock .icon img': {
      padding: '0px',
      margin: '0px',
      width: '18px',
      marginRight: '16px',
    },
    '& .listblock .icon.input-icon': {
      filter: theme.palette.formPage.filter,
      display: 'flex',
    },
    '& .listblock h1': {
      padding: '0px',
      margin: '0px',
      fontSize: '13px !important',
      textTransform: 'normal',
      color: `${theme.palette.formPage.titleTextColor} !important`,
      fontFamily: 'Roboto',
      fontWeight: '500 !important',
      '& @media (max-width:450px) ': {
        fontSize: '10px !important',
      },

    },
    '& .listblock h2': {
      padding: '0px',
      margin: '0px',
      fontSize: '12px !important',
      color: `${theme.palette.formPage.textColor} !important`,
      textTransform: 'none',
      fontFamily: 'Helvetica, sans-serif',
      lineHeight: '30px',
      marginLeft: '20px',
      fontWeight: '500 !important',
      '& @media (max-width:450px) ': {
        fontSize: '9px !important',
      },
    },
    '& .listblock .icon.selected': {
      padding: '0px',
      margin: '0px',
      background: '#EC2323',
      display: ['flex', 'flex'],
      justifyContent: 'center',
      alignItems: 'center',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      marginRight: '14PX',
      '& @media (max-width:450px) ': {
        width: '30px',
        height: '30px',
        marginRight: '10px',
        '& img': {
          width: '15px',
        },
      },
    },
    '& .listblock .icon.selected img': { padding: '0px', margin: ['0px', 'auto'] },
    '& .listblock .ch_lh': {
      padding: '0px',
      margin: '0px',
      lineHeight: '40px !important',
    },
    '& .darkmodal': { margin: '0px', padding: '0px' },
    '& .darkmodal .modal-dialog': { padding: '0px', marginTop: '150px !important' },
    '& .darkmodal .modal-content': {
      margin: '0px',
      padding: '0px',
      background: '#2C3148 !important',
    },
    '& .darkmodal .modal-content .close span': {
      margin: '0px',
      padding: '0px',
      color: '#fff !important',
      cursor: 'pointer',
      background: '#2C3148 !important',
    },
    '& .darkmodal .modal-header': {
      border: '0px !important',
      background: '#343950',
      padding: '18px',
    },
    '& .darkmodal .modal-footer': { border: '0px !important' },
    '& .darkmodal .modal-content .modal-body h2': {
      fontSize: '14px',
      textTransform: 'capitalize',
      color: '#fff',
      fontFamily: 'Helvetica, sans-serif',
      fontWeight: 500,
    },
    '& .modal.darkmodal': { background: 'rgb(17 17 17 / 55%) !important' },
    '& .darkmodal .modal-content .modal-body': {
      padding: '0px',
      display: 'block',
      width: '90%',
      margin: 'auto',
      background: 'rgb(244 255 246 / 2%)',
      border: '1px solid #099b4e',
      borderRadius: '9px',
      marginTop: '30px',
    },

    '& #msform  > div:first-of-type': {
      backgroundColor: 'transparent',
      paddingBottom: 14,
      maxWidth: '847px',
      margin: 'auto',
      marginBottom: '16px',
    },
    '& > div:nth-child(3) > div': {
      '& .dialogTitle': {
        display: 'none',
      },
    },
    '& a, .btn': {
      WebkitTransition: 'all 0.3s ease-out 0s',
      MozTransition: 'all 0.3s ease-out 0s',
      msTransition: 'all 0.3s ease-out 0s',
      OTransition: 'all 0.3s ease-out 0s',
      transition: 'all 0.3s ease-out 0s',
      color: '#353535',
    },
    '& a:focus': { textDecoration: 'none !important' },
    '& a:focus, a:hover': { color: '#cccccc', textDecoration: 'none !important' },
    '& a, button, input': { outline: 'medium none !important', color: '#292929s' },
    '& h1, h2, h3, h4, h5, h6': {
      fontFamily: "'Roboto', sans-serif",
      fontWeight: 'normal',
      color: '#353535',
      marginTop: '0px',
      marginBottom: '0px',
      textTransform: 'capitalize',
    },
    '& h1 a, h2 a, h3 a, h4 a, h5 a, h6 a': { color: 'inherit' },
    '& h1': {
      fontSize: '54px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '54px',
    },
    '& h2': {
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '40px',
      fontSize: '18px',
      textTransform: 'uppercase',
      color: '#fff',
      marginBottom: '10px',
      textAlign: 'center',
      fontFamily: 'Helvetica, sans-serif',
    },
    '& h3': {
      fontSize: '28px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '36px',
    },
    '& h4': {
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '32px',
    },
    '& h5': {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '30px',
    },
    '& h6': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '24px',
    },
    '& h1.title2': {
      fontSize: '50px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '56px',
    },
    '& h2.title2': {
      fontSize: '40px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '50px',
    },
    '& h3.title2': {
      fontSize: '38px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '48px',
    },
    '& h4.title2': {
      fontSize: '34px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '40px',
    },
    '& h5.title2': {
      fontSize: '30px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '36px',
    },
    '& h6.title2': {
      fontSize: '26px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '32px',
    },
    '& .MarginSet>div': {
      marginBottom: '25px',
      padding: '0px 19px',
    },
    '& .title2 > label': { color: '#ffd200', fontWeight: 600 },
    '& ul': { margin: '0px', padding: '0px' },
    '& hr': {
      margin: '0',
      padding: '0px',
      borderBottom: '1px solid #e0e0e0',
      borderTop: '0px',
    },
    '& label': { fontWeight: 400, color: '#aaaaaa!important' },
    '& .label': { color: '#fff !important', fontSize: '9px !important' },
    '& *::-moz-selection': {
      background: '#ffd200',
      color: '#fff',
      textShadow: 'none',
    },
    '& ::-moz-selection': {
      background: '#ffd200',
      color: '#fff',
      textShadow: 'none',
    },
    '& ::selection': { background: '#ffd200', color: '#fff', textShadow: 'none' },
    '& .text-white h1, .text-white h2, .text-white h3, .text-white h4, .text-white h5, .text-white h6': {
      color: '#ffffff',
    },
    '& .text-white h1.text-yellow, \n.text-white h2.text-yellow, \n.text-white h3.text-yellow, \n.text-white h4.text-yellow, \n.text-white h5.text-yellow, \n.text-white h6.text-yellow': {
      color: '#ffd200',
    },
    '& mark': { background: '#ffd200', color: '#ffffff' },
    '& ol': { padding: '0px', margin: '0px' },
    '& ol li': {
      listStyle: 'decimal inside',
      padding: '0px',
      margin: '0px',
      lineHeight: '30px',
    },
    '&  ol.alpha li': {
      listStyle: 'decimal-leading-zero inside',
      padding: '0px',
      margin: '0px',
    },
    '& ol.roman li': { listStyle: 'lower-roman', padding: '0px', margin: '0px' },
    '& ul li': {
      listStyle: 'square inside',
      padding: '0px',
      margin: '0px',
      lineHeight: '30px',
    },
    '& ul.disc li': {
      listStyle: 'disc inside',
      padding: '0px',
      margin: '0px',
      lineHeight: '30px',
    },
    '& ul.list-style-1 li': { listStyle: 'none' },
    '& ul.list-unstyled li': { listStyle: 'none' },
    '& .action-box.withusbg': {
      padding: '0px',
      margin: '0px',
      marginBottom: '40px',
    },
    '& .action-box.withusbg .col-md-offset-1': { marginLeft: '11.33333333%' },
    '& .justify-center': {
      justifyContent: 'center',
    },

    '& .action-box.withusbg h1': {
      fontFamily: "'Helvetica', sans-serif",
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '30px',
      color: '#fff',
    },
    '& .action-button-previous': {
      width: '100px',
      background: 'transparent',
      fontWeight: 'bold',
      color: 'white',
      border: '1px solid #fff',
      borderRadius: '25px',
      cursor: 'pointer',
      transition: '0.7s',
      padding: '10px 5px',
      margin: '10px 5px',
    },

    '& .MuiStepLabel-label': {
      fontFamily: 'Helvetica, sans-serif',
      textTransform: 'uppercase',
    },
    '& .MuiStepLabel-alternativeLabel': {
      fontFamily: 'Helvetica, sans-serif',
      textTransform: 'uppercase',
      fontSize: '13px',
      color: theme.palette.formPage.color,
      '@media only screen and (max-width:925px) ': {
        fontSize: '10px',
      },
    },

    '& .field-set': {
      background: '#222538',
      border: '0 none',
      borderRadius: '12px',
      padding: '20px 30px',
      boxSizing: 'border-box',
      width: '100%',
      marginBottom: '40px',
      //   marginTop: '20px',
      textAlign: 'center',
      maxWidth: '847px',
      margin: '0 auto',
    },
    '& .action-button': {
      width: '100px',
      background: '#0aaf58',
      fontWeight: 'bold',
      color: 'white',
      border: '0 none',
      borderRadius: '25px',
      cursor: 'pointer',
      padding: '12px 22px',
      margin: '10px 5px',
      fontSize: '14px',
      transition: '0.7s',
    },
    '& .action-box .mainlogo': {
      padding: '0px',
      margin: '0px',
      paddingTop: '50px',
      // marginTop: "50px",
      marginBottom: '20px',
    },
    '& .action-box .mainlogo img': {
      padding: '0px',
      margin: '0px',
      width: '260px',
    },
    '& .form': {
      display: 'flex',
      alignItems: 'center',
      '& input,textarea': {
        width: '100%',
        background: 'none',
        border: 'none',
        resize: 'none',
        color: theme.palette.formPage.color,
        fontSize: '16px',
      },
      position: 'relative',
      height: '55px',
      overflow: 'visible',
      borderRadius: '40px',
    },

    '& .form.message': {
      boxShadow: theme.palette.formPage.fieldShadow,
      position: 'relative',
      height: 'auto',
      overflow: 'hidden',
      //   boxShadow: theme.palette.formPage.fieldShadow,
      borderRadius: '25px',
      '& textarea': {
        fontFamily: 'inherit',
      },
    },
    '& .error-message': {
      display: 'none',
    },
    '& .form.error-msg': {
      marginBottom: '4px',
      border: '1px solid #f35252!important',
      // '&  input,textarea':{
      // },
      '&.form input:focus + .label-name .content-name,\n.form input:valid + .label-name .content-name': {
        color: '#f35252!important',
      },
      '&.form textarea:focus + .label-name .content-name,\n.form textarea:valid + .label-name .content-name': {
        color: '#f35252!important',

      },
      '& .error-message': {
        textAlign: 'left',
        paddingLeft: '20px',
        paddingTop: '2px',
        color: '#f35252',
        fontSize: '11px',
        margin: '0px',
        display: 'block',
        left: ' 0px',
        bottom: '-25px',
        position: 'absolute',
      },
    },
    '& .form ': {
      width: '100%',
      color: theme.palette.formPage.color,
      resize: 'none',
      fontWeight: 'normal',
      fontFamily: 'Helvetica, sans-serif',
      border: 'none',
      fontSize: '14px',
      backgroundColor: theme.palette.formPage.backgroundColorInput,
      borderRadius: '40px',
      paddingLeft: '30px',
      paddingRight: '54px',
      paddingTop: '15px',
      paddingBottom: '15px',

      boxShadow: '0px 12px 12px rgba(0, 0, 0, 0.08)',
    },
    // '& .phone': {
    //   width: '100%',
    //   height: '100%',
    //   color: theme.palette.formPage.color,
    //   resize: "none",
    //   fontWeight: 'normal',
    //   fontFamily:"Helvetica, sans-serif",
    //   border: 'none',
    //   fontSize: '14px',
    //   backgroundColor: theme.palette.formPage.backgroundColorInput,
    //   borderRadius: '40px',
    //   paddingLeft: '30px',
    //   paddingRight: '45px',
    //   paddingBottom: '15px',

    //   boxShadow: '0px 12px 12px rgba(0, 0, 0, 0.08)'
    // },
    '& .w-set': {
      width: '48%',
    },
    '& .p-0': {
      padding: '0px !important',
    },
    '& .padding-set': {
      paddingLeft: '15px',
      paddingRight: '15px',
    },

    '& .form .fname img': {
      filter: theme.palette.formPage.filter,
    },
    '& .form label': {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      borderBottom: '0px solid white',
    },
    '& .form label::after': {
      content: '""',
      position: 'absolute',
      bottom: '-1px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderBottom: '0px solid #fce38a',
      transform: 'translateX(-100%)',
      transition: 'all 0.3s ease',
    },
    '& .content-name': {
      position: 'absolute',
      bottom: '3px',
      left: '30px',
      paddingBottom: '12px',
      transition: 'all 0.3s ease',
    },
    '& .form.message .content-name': {
      position: 'absolute',
      top: '13px',
      left: '31px',
      transition: 'all 0.3s ease',
    },
    '& .form input:focus, .form textarea:focus': { outline: 'none' },
    '& .form input:focus + .label-name .content-name,\n.form input:valid + .label-name .content-name': {
      transform: 'translateY(-41%)',
      fontSize: '10.5px',
      left: '30px',
      color: '#1abd67',
    },
    '& .form textarea:focus + .label-name .content-name,\n.form textarea:valid + .label-name .content-name': {
      transform: 'translateY(-11%)',
      fontSize: '10.5px',
      left: '30px',
      color: '#1abd67',
    },
    '& .form input:focus + .label-name::after,.form input:valid + .label-name::after,.form textarea:focus + .label-name::after,\n.form textarea:valid + .label-name::after': {
      transform: 'translateX(0%)',
    },
    '& .form.fname img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '28%',
      width: '18px',
    },
    '& .form .field-icon': {
      filter: theme.palette.formPage.filter,

    },
    '& .form.email img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '37%',
      width: '21px',
    },

    '& .form.company > img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '30%',
      width: '20px',
    },
    '& .form.phone .content-name': {
      left: '30px',
      fontSize: '10.5px',
      transform: 'translateY(-46%)',
    },
    '& .form.phone > img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '30%',
      width: '20px',
    },
    '& .form.phone': {
      '& input:focus  .content-name': {

      },

    },
    // '& .PhoneInputCountry': {
    //   display:"none"
    // },
    // '& .form.country input:focus .PhoneInputCountry ': {
    //   display:"block",
    // },
    '& .form.country': {
      display: 'flex',
      '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
        left: '0px',
        color: '#1abd67!important',
        fontSize: '10.5px',
        transform: 'translateY(11%)',
      },
      '& .MuiFormControl-root': {
        width: '100%',
        '& label': {
          left: '-13px',
          width: '100%',
          top: '-17px',
          textAlign: 'left',
          fontSize: '14px',
        },

        '& .MuiSelect-select:focus': {
          backgroundColor: 'transparent',
        },
        '& .MuiFilledInput-root': {
          backgroundColor: 'transparent',
          height: '100%',
          '& .MuiSelect-selectMenu': {
            padding: '0px',
            color: theme.palette.formPage.color,
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            '& > img': {
              position: 'inherit',
              padding: '0px',
              margin: '0px',
              right: '0%',
              top: '0%',
              width: '26px',
              height: '16px',
              paddingRight: '0px!important',
              marginRight: '10px',
            },
          },
        },
        '& .MuiFilledInput-underline:before': {
          display: 'none',
        },
        '& .MuiFilledInput-underline:after': {
          display: 'none',
        },
      },
    },
    '& .form.phone .PhoneInput': {
      height: '100%',
      width: '100%',
    },
    '& .form.phone .PhoneInputCountryIcon': {
      position: 'inherit',
      padding: '0px',
      margin: '0px',
      right: '0%',
      top: '0%',
      width: '26px',
      height: '17px',
      boxShadow: 'none',
    },

    '& .form.country > img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '30%',
      width: '20px',
    },
    '& .form.message >img': {
      position: 'absolute',
      padding: '0px',
      margin: '0px',
      right: '30px',
      top: '11%',
      width: '20px',
    },
    '& .action-box .submit img': {
      margin: '0px',
      padding: '0px',
      width: '100%',
      cursor: 'pointer',
    },
    '& .platform': { padding: '0px', margin: '0px' },
    '& .platform h1': {
      fontFamily: "'Helvetica', sans-serif",
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '30px',
      letterSpacing: '1px',
      textDecoration: 'underline',
      color: '#fff',
    },
    '& .mb5 ': {
      marginBottom: '5px',
    },
    '& .mt35': {
      marginTop: '35px',
    },
    '& .w-link .mb5 ': {
      width: '100%',
    },

    '& .p-set': {
      padding: '0px 20px',
    },
    '& .inside-block': {
      padding: '0px',
      margin: '0px',

      background: theme.palette.formPage.cardBackgroundColor,
      marginBottom: '39px',
      borderRadius: '12px',
      transition: '0.8s',
      minHeight: '120px',
      boxShadow: theme.palette.formPage.shadowbox,
    },

    '& .inside-block .icon': {
      padding: '0px',
      margin: ' auto',
      background: '#2F324A',
      width: '62px',
      height: '62px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '28px',
      border: '1.5px solid transparent',
      transition: '0.8s',
      boxShadow: '0px 0px 0px 7px rgba(0, 0, 0, 0.12)',
    },
    '& .inside-block:hover': {
      padding: '0px',
      margin: '0px',
      background: '#292C41',
      cursor: 'pointer',
      marginBottom: '39px',
      borderRadius: '12px',
      minHeight: '120px',
      boxShadow: '5px 5px 20px 6px rgb(0 0 0 / 18%)',
    },
    '& .inside-block:hover .icon': {
      padding: '0px',
      margin: 'auto',
      background: '#EC2323',
      width: '62px',
      height: '62px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '28px',
      border: '1.5px solid transparent',
      transition: '0.8s',
      boxShadow: '0px 0px 0px 7px rgba(0, 0, 0, 0.12)',
    },
    '& .selected img': {
      marginRight: '0px!important',
    },
    '& .selected': {
      background: ' #EC2323',
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      marginRight: '14PX',
    },
    '& .inside-block .icon img': {
      padding: '0px',
      margin: '0px',
      width: '54%',
      marginTop: '4px',
    },
    '& .inside-block h2': {
      fontFamily: "'Helvetica', sans-serif",
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      textDecoration: 'normal',
      textTransform: 'uppercase',
      color: theme.palette.formPage.color,
      lineHeight: '24px',
      alignItems: 'center',
      transition: '0.8s',
      height: '118px',
      justifyContent: 'flex-start',
      display: 'flex',
      textAlign: 'left',
    },
    '@media (max-width:1280px) ': {
      '& .inside-block:hover h2': {
        height: '80px!important',
        justifyContent: 'center!important',
      },
      '& .inside-block h2': {
        height: '80px',
        justifyContent: 'center',
      },
    },
    '& .inside-block:hover h2': {
      fontFamily: "'Helvetica', sans-serif",
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      textDecoration: 'normal',
      textTransform: 'uppercase',
      color: '#fff',
      lineHeight: '24px',
      alignItems: 'center',
      height: '118px',
      transition: '0.8s',
      paddingLeft: '0px',
      justifyContent: 'flex-start',
      display: 'flex',
      textAlign: 'left',
    },

    '& .pam-active': {
      transition: '0.7s',
      background: '#EC2323 !important',
    },
    '& .es-active': {
      transition: '0.7s',
      background: '#0165F7 !important',
    },
    '& .dt-active': {
      transition: '0.7s',
      background: '#F5BE10 !important',
    },
    '& .ztn-active': {
      transition: '0.7s',
      background: '#6ABDC3 !important',
    },
    '& .eps-active': {
      transition: '0.7s',
      background: '#0BE00A !important',
    },
    '& .sat-active': {
      transition: '0.7s',
      background: '#D300FF !important',
    },
    '& .sfs-active': {
      transition: '0.7s',
      background: '#701ce1 !important',
    },
    '& .av-active': {
      transition: '0.7s',
      background: '#0BE00A !important',
    },
    '& .cip-active': {
      transition: '0.7s',
      background: '#3865B7 !important',
      '& h2': {
        color: '#FFF !important',
      },
    },

    '& .inside-block.sfs:hover': {
      transition: '0.7s',
      background: '#701ce1 !important',
    },
    '& .inside-block.sfs:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.sfs': {
      background: `${theme.palette.formPage.sfsBackgroundColor} !important`,
      border: '1.5px solid #701ce1 !important',
    },
    '& .inside-block:hover .icon.sfs': {
      background: `${theme.palette.formPage.sfsBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },

    '& .inside-block.av:hover': {
      transition: '0.7s',
      background: '#0BE00A !important',
    },
    '& .inside-block.av:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.av': {
      background: `${theme.palette.formPage.avBackgroundColor} !important`,
      border: '1.5px solid #0BE00A !important',
    },
    '& .inside-block:hover .icon.av': {
      background: `${theme.palette.formPage.avBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },

    '& .inside-block.cip:hover': {
      transition: '0.7s',
      background: '#3865B7 !important',
    },
    '& .inside-block.cip:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.cip': {
      background: `${theme.palette.formPage.cipBackgroundColor} !important`,
      border: '1.5px solid #3865B7 !important',
    },
    '& .inside-block:hover .icon.cip': {
      background: `${theme.palette.formPage.cipBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },

    '& .inside-block.sat:hover': {
      transition: '0.7s',
      background: '#D300FF !important',
    },
    '& .inside-block.sat:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.sat': {
      background: `${theme.palette.formPage.satBackgroundColor} !important`,
      border: '1.5px solid #D300FF !important',
    },
    '& .inside-block:hover .icon.sat': {
      background: `${theme.palette.formPage.satBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },

    '& .title-active h2': { color: '#fff ' },

    '& .inside-block.pam:hover': {
      transition: '0.7s',
      background: '#EC2323 !important',
    },
    '& .inside-block.pam:hover h2': { color: '#fff !important' },

    '& .inside-block .icon.pam': {
      background: `${theme.palette.formPage.pamBackgroundColor} !important`,
      border: '1.5px solid #EC2323 !important',
    },
    '& .inside-block:hover .icon.pam': {
      background: `${theme.palette.formPage.pamBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.es:hover': {
      transition: '0.7s',
      background: '#0165F7 !important',
    },
    '& .inside-block.es:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.es': {
      background: `${theme.palette.formPage.esBackgroundColor} !important`,
      border: '1.5px solid #0165F7 !important',
    },
    '& .inside-block:hover .icon.es': {
      background: `${theme.palette.formPage.esBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.dt:hover': {
      transition: '0.7s',
      background: '#F5BE10 !important',
    },
    '& .inside-block.dt:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.dt': {
      background: `${theme.palette.formPage.dtBackgroundColor} !important`,
      border: '1.5px solid #F5BE10 !important',
    },
    '& .inside-block:hover .icon.dt': {
      background: `${theme.palette.formPage.dtBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.up:hover': {
      transition: '0.7s',
      background: '#0F9953 !important',
    },
    '& .inside-block.up:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.up': { border: '1.5px solid #0F9953 !important' },
    '& .inside-block:hover .icon.up': {
      background: '#292C41 !important',
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.ztn:hover': {
      transition: '0.7s',
      background: '#6ABDC3 !important',
    },
    '& .inside-block.ztn:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.ztn': {
      background: `${theme.palette.formPage.ztnBackgroundColor} !important`,
      border: '1.5px solid #6ABDC3 !important',
    },
    '& .inside-block:hover .icon.ztn': {
      background: `${theme.palette.formPage.ztnBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.pp:hover': {
      transition: '0.7s',
      background: '#F1264B !important',
    },
    '& .inside-block.pp:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.pp': { border: '1.5px solid #F1264B !important' },
    '& .inside-block:hover .icon.pp': {
      background: '#292C41 !important',
      border: '1.5px solid transparent !important',
    },
    '& .inside-block.eps:hover': {
      transition: '0.7s',
      background: '#0BE00A !important',
    },
    '& .inside-block.eps:hover h2': { color: '#fff !important' },
    '& .inside-block .icon.eps': {
      background: `${theme.palette.formPage.epsBackgroundColor} !important`,
      border: '1.5px solid #0BE00A !important',
    },
    '& .inside-block:hover .icon.eps': {
      background: `${theme.palette.formPage.epsBackgroundColor} !important`,
      border: '1.5px solid transparent !important',
    },
    '& .platform .submit img': {
      padding: '0px',
      width: '45%',
      cursor: 'pointer',
      margin: 'auto',
      display: 'block',
      marginBottom: '50px',
    },
    '& @media only screen and (max-width:1025px) and (min-width:770px)': {
      '& .action-box .submit img': {
        margin: ['0 0 0 auto', 'auto'],
        padding: '0px',
        width: '60%',
        cursor: 'pointer',
        display: 'block',
      },
      '& .inside-block .icon': {
        margin: 'auto',
        width: '90px',
        height: '90px',
        marginTop: '28px',
      },
      '& .inside-block:hover .icon': {
        padding: '0px',
        margin: 'auto',
        background: '#EC2323',
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '28px',
        border: '1.5px solid transparent',
        transition: '0.8s',
        boxShadow: '0px 0px 0px 7px rgba(0, 0, 0, 0.12)',
      },
      '& .inside-block h2': {
        fontFamily: "'Helvetica', sans-serif",
        fontSize: '15px',
        fontStyle: 'normal',
        // fontWeight: 400,
        textDecoration: 'normal',
        textTransform: 'uppercase',
        lineHeight: '70px',
        letterSpacing: '0px',
        alignItems: 'none',
        height: 'auto',
        justifyContent: 'normal',
        display: 'block',
        textAlign: 'center',
      },
      '& .inside-block:hover h2': {
        fontFamily: "'Helvetica', sans-serif",
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 400,
        textDecoration: 'normal',
        textTransform: 'uppercase',
        color: '#fff',
        lineHeight: '70px',
        alignItems: 'initial',
        height: 'auto',
        transition: '0.8s',
        justifyContent: 'normal',
        display: 'block',
        textAlign: 'center',
      },
      '& .platform .submit img': {
        padding: '0px',
        width: '60%',
        cursor: 'pointer',
        margin: 'auto',
        display: 'block',
        marginBottom: '50px',
      },
    },
    '@media (max-width: 768px)': {
      '& .action-box .submit img': {
        margin: ['0 0 0 auto', 'auto'],
        padding: '0px',
        width: '80%',
        cursor: 'pointer',
        display: 'block',
      },
      '& .inside-block .icon': {
        margin: 'auto',
        width: '90px',
        height: '90px',
        marginTop: '28px',
      },
      '& .inside-block:hover .icon': {
        padding: '0px',
        margin: 'auto',
        background: '#EC2323',
        width: '90px',
        height: '90px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '28px',
        border: '1.5px solid transparent',
        transition: '0.8s',
        boxShadow: '0px 0px 0px 7px rgba(0, 0, 0, 0.12)',
      },
      '& .inside-block h2': {
        fontFamily: "'Helvetica', sans-serif",
        fontSize: '13px',
        fontStyle: 'normal',
        // fontWeight: 400,
        textDecoration: 'normal',
        textTransform: 'uppercase',
        //   lineHeight: "70px",
        letterSpacing: '0px',
        alignItems: 'none',
        height: 'auto',
        justifyContent: 'center!important',
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '20px',
      },
      '& .platform .submit img': {
        padding: '0px',
        width: '70%',
        cursor: 'pointer',
        margin: 'auto',
        display: 'block',
        marginBottom: '50px',
      },
    },

    // /*progressbar*/
    // #progressbar {
    //     margin-bottom:14px;
    //     overflow: hidden;
    //     /*CSS counters to number the steps*/
    //     counter-reset: step;
    //         padding-top: 14px;
    // }

    // #progressbar li {
    //     list-style-type: none;
    //     color: white;
    //     text-transform: uppercase;
    //     font-size:13px;
    //     font-weight:500;
    //     width: 33%;
    //     font-family: Helvetica;
    //     float: left;
    //     position: relative;
    //     letter-spacing: 0.5px;
    // }

    // #progressbar li:before {
    //     content: counter(step);
    //     counter-increment: step;
    //     width:55px;
    //     height:55px;
    //     line-height:55px;
    //     display: block;
    //     font-size: 22px;
    //     font-family: Helvetica;
    //     color: #333;
    //     font-weight: 600;
    //     background: white;
    //     border-radius:50%;
    //     margin: 0 auto 10px auto;
    //     box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.33);
    // }

    // /*progressbar connectors*/
    // #progressbar li:after {
    //     content: '';
    //     width: 100%;
    //     height:1px;
    //     background: white;
    //     position: absolute;
    //     left: -50%;
    //     top:26px;
    //     z-index: -1; /*put it behind the numbers*/
    // }

    // #progressbar li:first-child:after {
    //     /*connector not needed before the first step*/
    //     content: none;
    // }

    // /*marking active/completed steps green*/
    // /*The number of the step and the connector before it = green*/
    // #progressbar li.active:before, #progressbar li.active:after {
    //     background: #09af58;
    //     color: white;
    // }
  },

  '&highlight': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.dark,
  },

  random: {
    '& > div > div > div > div:nth-child(2) > div': {
      marginTop: '50px',
    },
  },
  indicator: {
    backgroundColor: '#02B959',
  },
  showMore: {
    color: '#189b54',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'space-between',
    // zIndex:9,
    '& h4': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  '& .MuiPickersCalendarHeader-dayLabel': {
    // '& .dayLabel':{
    color: 'yellow',
  },

  pageChng: {
    '& svg path': {
      fill: theme.palette.text.primary,
    },
  },
  pageIcon: {
    '& svg': {
      width: '26px!important',
      height: '26px!important',
      fill: theme.palette.text.primary,
    },
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  buttonSetCol: {
    background: '#01BD5A',
    fontSize: '10px',
    borderRadius: '26px',
    color: '#fff',
    width: '90px',
    height: '36.81px',

    '&:hover': {
      background: '#01BD5A',
    },
    '& svg': {
      border: '1px solid white',
      borderRadius: '26px',
      width: '14.6px',
      height: '14px',
      marginRight: '8px',
    },
  },
  dFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    top: '10px',
    position: 'relative',
  },
  divRel: {
    marginRight: '20px',
    width: '60px',
    height: '60px',
    background: theme.palette.sidebarBackground.color,
    border: `1px dashed ${theme.palette.primary.botBorderColor}`, // #444A76', //#D5D5D5
    boxSizing: 'border-box',
    borderRadius: '0px 66px 66px 66px',
    position: 'relative',
  },
  showIcons: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 4,
    '& > div': {
      width: 20,
      height: 20,
      //   border:'2px solid ' + theme.palette.actionBtnBorder.color,
      border: theme.palette.actionBtnBorderCol.border,
      background: theme.palette.actionBtnBorderCol.color,

      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 4,
      '& svg': {
        fontSize: 14,
        fill: theme.palette.tableDis.color,
      },
      '&:hover': {
        background: theme.palette.actionBtnBorder.color,
        '& svg': {
          fill: '#fff',
        },
      },
    },
  },

  datePickerIcons: {
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    '& span + div': {
      marginTop: 5,
    },
  },
  freezeBtn: {
    border: theme.palette.actionBtnBorder.border,
    color: theme.palette.actionBtnBorder.bili,
    // borderRadius: 4,
    background: theme.palette.actionBtnBorder.background,
    padding: '3px 12px',
    textTransform: 'capitalize',
    boxShadow: 'none',
    borderRadius: '20px',
    '& span': {
      fontSize: '11px !Important',
    },
    '& svg': {
      fill: theme.palette.actionBtnBorder.bili,
      fontSize: '15px!important',
      marginLeft: '0px',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
  },
  unfreezeBtn: {
    border: `1px solid ${theme.palette.actionBtnBorder.color}`,
    color: '#fff',
    boxShadow: 'none',
    borderRadius: 4,
    backgroundColor: theme.palette.actionBtnBorder.color,
    padding: '4px 12px',
    textTransform: 'capitalize',
    '& svg': {
      fill: '#fff',
    },
    '&:hover': {
      backgroundColor: theme.palette.actionBtnBorder.color,
      boxShadow: 'none',
      '& svg': {
        fill: '#fff',
      },
    },
  },
  datePickerUi: {
    marginTop: '10px',
    paddingLeft: '0px',
    '& button': {
      padding: 6,
      '& svg': {
        fontSize: 20,
      },
    },
    '& input': {
      display: 'none',
    },
  },
  datePickerBlock: {
    position: 'relative',
  },
  expired: {
    color: '#f00',
    minWidth: 48,
  },
  showText: {
    // minWidth:48
    borderRadius: '20px',
    padding: '4px 8px',
    // border:"1px solid #02B959",
    border: theme.palette.showTextC.border,
    color: theme.palette.showTextC.color,
    background: theme.palette.showTextC.background,
  },
  copyBtn: {
    // background: theme.palette.primary.popup,
    background: '#01BD5A',
    borderRadius: 20,
    float: 'right',
    padding: '10px 48px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.9,
    },
  },
  wordBreak: {
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap',
  },
  license_box: {
    maxHeight: 'calc(100vh - 220px)',
    overflow: 'auto',
    background: theme.palette.defaultBtnShadow.color,
    padding: '21px',
    marginBottom: '43px',
  },
  dataTablePakage: {
    // marginTop:"4rem",
    position: 'relative',
    '&.dataTablePakagePadding': {
      // backgroundColor: theme.palette.mainTableLayoutBg.color,
      // border:'1px solid ' + theme.palette.mainTableBorder.color,
      // padding:'10px 20px 10px'
    },
  },
  externalSearch: {
    position: 'absolute',
    left: 10,
    top: 29,
    zIndex: 9,
    '@media (min-width: 1399px)': {
      left: 25,
    },
  },
  openAddModal: {
    right: 0,
    top: 0,
    left: 'inherit',
    borderRadius: '50%',
    textAlign: 'center',
    padding: '0',
    fill: theme.palette.secondary.contrastText,
    color: theme.palette.primary.contrastText,
    cursor: 'pointer',
    border: `2px solid ${theme.palette.actionBtnBorder.color}`,
    position: 'relative',
    width: 32,
    height: 32,
    // marginLeft: 'auto',
    '& svg': {
      fill: theme.palette.actionBtnBorder.color,
    },
    '&:hover': {
      backgroundColor: `${theme.palette.actionBtnBorder.color}!important`,
      '& svg': {
        fill: '#fff',
      },
    },
    '&:focus': {
      outline: 'none',
    },
    '@media (max-width:767px)': {
      top: 0,
    },
    '@media (max-width:650px)': {
      width: '23px',
      height: '23px',
    },
  },
  buttonSize: {
    width: 32,
    height: 32,
    padding: 0,
    '@media (max-width:650px)': {
      width: 23,
      height: 23,
    },
  },
  formInput: {
    width: 222,
    minWidth: 65,
    float: 'left',
    fontSize: '16px',
    border: 0,
    borderBottom: `${theme.palette.primary.searchBorder} solid 1px`,
    background: 'none',
    color: theme.palette.secondary.contrastText,
    padding: '7px 10px 7px 30px',
    resize: 'none',
    borderRadius: 0,
  },
  searchIcon: {
    fill: theme.palette.secondary.contrastText,
    position: 'absolute',
    left: 0,
    top: 6,
    height: 20,
  },
  linkColorTd: {
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  removePadding: {
    '& table tbody td': {
      padding: '0px !important',
    },
  },

  paddingTwoFiveClientTable: {
    '& > div > div:nth-child(1)': {
      top: '15px !important',
      right: '69px !important',
      zIndex: 2,
    },
    '& > div': {
      '& > div + div > div > div': {
        '& > div': {
          paddingTop: '4rem',
        },
      },
    },
  },
  paddingTwoFiveThree: {
    '& table tbody tr td:last-child .searchField button span svg': {
      fill: 'currentColor !important',
    },
    '&  > div > div + div > div > div > div': {
      margin: '0px !important',
    },
    '& > div > div:nth-child(1)': {
      top: '-50px !important',
      right: '8px !important',
      '& .positionEnd button span svg': {
        fill: 'currentColor !important',
        width: '20px',
        height: '20px',
      },
    },
  },

  paddingTwoFive: {
    '& > div': {
      borderRadius: '8px',
    },
    // "& > div > div:nth-child(1)":{
    //         top: '-43px !important',
    // },
    marginTop: '3rem',
    '& table thead th:first-child': {
      borderTopLeftRadius: '10px',
    },
    '& table thead th:last-child': {
      borderTopRightRadius: '10px',
    },
    '& table tbody tr:last-child': {
      '& td:first-child': {
        borderBottomLeftRadius: '10px',
      },
      '& td:last-child': {
        borderBottomRightRadius: '10px',
      },
    },
    // '& table tbody td:last-child':{
    //     borderBottomRightRadius: "10px",
    // },

    '& table tbody tr td:last-child button': {
      border: `1px solid ${theme.palette.actionBtnBorder.colorBorder}`,
      background: theme.palette.childBtn.background,
      height: '25px',
      width: '25px',
    },
    '& table tbody tr:nth-child(even)': {
      // backgroundColor: "#282B3E!important",
      backgroundColor: theme.palette.tdCol.background,
    },
    '& table tbody tr td:last-child button svg': {
      fill: theme.palette.actionBtnBorder.colorBorder,
      height: '13px!important',
      width: '13px !important',
    },

    '& > div > div:nth-child(1)': {
      position: 'absolute',
      right: 110,
      color: '#74799D',
      top: '-86px',
      background: theme.palette.searchBar.background,
      boxShadow: theme.palette.searchBar.boxShadow,
      borderRadius: '44px',
      minHeight: 'unset!Important',
      paddingRight: '0px !important',
      paddingLeft: '40px',
      paddingTop: '3px',
      paddingBottom: '3px',
      width: '29vw',
      maxWidth: '537px!important',
      marginBottom: '20px',
      '& div': {
        color: '#74799D!important',
        '&  svg': {
          fill: '#74799D!important',
        },
        '&  button': {
          border: '0px!important',
        },
        '&  button svg': {
          width: '20px!important',
          height: '20px!important',
        },
        fontSize: '15px',
      },

      '& input + div button': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },

    '& :after': {
      transform: 'scaleX(0) !important',
      borderBottom: 'none !important',
    },
    '& :before': {
      transform: 'scaleX(0) !important',
      borderBottom: 'none !important',
    },
    '& .flagImage': {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        fill: theme.palette.modalTextColor.color,
        width: '25px',
        height: '25px',
        marginRight: '5px',
      },
    },
    '& > div': {
      backgroundColor: theme.palette.mainLayout.color,
      '& > div + div > div > div': {
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        padding: '0px 0px',
        backgroundColor: `${theme.palette.tableTbodyBg.color}!important`,
        '& > div': {
          margin: '20px',
        },
      },
      '@media (max-width:767px)': {
        marginTop: 0,
      },
    },
    '& table tr th p': {
      color: theme.palette.tdCol.color,
    },
    '& table tr th': {
      backgroundColor: `${theme.palette.tableTbodyBg.color}!important`,
      border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
      whiteSpace: 'nowrap',
      '&:last-child': {
        '& svg': {
          display: 'none',
        },
      },
      '& span': {
        color: theme.palette.tdCol.color,
      },
    },
    '& table tbody tr td:last-child': {
      '& div': {
        justifyContent: 'flex-start',
        '&.downloadBtn': {
          justifyContent: 'flex-start',
          marginLeft: '20px',
        },
      },
      '& button': {
        border: `1px solid ${theme.palette.actionBtnBorder.color}`,
        '& svg': {
          fill: theme.palette.actionBtnBorder.color,
          width: 20,
          height: 20,
          fontSize: 20,
        },
        '&:hover': {
          backgroundColor: theme.palette.actionBtnBorder.colorS,
          border: `2px solid ${theme.palette.actionBtnBorder.colorBorder}!important`,
          '& svg': {
            fill: `${theme.palette.actionBtnBorder.colorBorder}!important`,
          },
        },
      },
    },
    '& tfoot': {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
      borderTop: 0,
      '& tr': {
        '& td': {
          borderBottomColor: theme.palette.primary.light,
          '& button': {
            padding: '6px',
          },
          '@media (max-width:400px)': {
            '& .MuiTablePagination-select': {
              paddingRight: 20,
              '& > div': {
                padding: '0 !important',
              },
            },
            '& button': {
              padding: '12px 0',
            },
          },
        },
      },
    },
    '& .downloadBtn': {
      display: 'flex',
      justifyContent: 'flex-start',
      marginBottom: 20,
      marginTop: 20,
      '& button': {
        margin: '0 !important',
        display: 'flex',
        justifyContent: 'center',
        '&.activeButton': {
          textTransform: 'capitalize',
          width: 'auto',
          minWidth: 120,
          minHeight: 42,
          lineHeight: '42px',
          textAlign: 'center',
          padding: '0 12px',
          border: 0,
          color: '#fff',
          background: '#01BD5A',
          float: 'right',
          marginLeft: 15,
          marginBottom: 5,
          borderRadius: '20px !important',
          '&:hover': {
            background: '#189b54',
            opacity: 0.9,
          },
        },
      },
    },
    '& .detailExpansionCus': {
      height: 'auto !important',
      border: 'none !important',
    },
    '& .detailExpansionPanelRow': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: theme.palette.secondary.contrastText,

      border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
      height: '56px',
      '& .span1': {
        width: '30%',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
        alignItems: 'center',
        height: '100%',
        background: theme.palette.primary.bg3,
        fontWeight: 'bold',
        fontSize: '14px',
        borderLeft: 'none',
        // borderBottom:"none",
      },

      '& .span2': {
        wordBreak: 'break-word',
        border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
        height: '100%',
        width: '70%',
        display: 'flex',
        textTransform: 'capitalize',
        paddingLeft: '20px',
        alignItems: 'center',
        borderLeft: 'none',
        borderRight: 'none',
        // borderBottom:"none",
      },
    },
    '& .outer-panel-custom': {
      // margin: '-16px !important',
      marginBottom: '-16px !important',
      padding: '0px !important',
    },

    '& .outer-panel': {
      // background: theme.palette.tableBorderTransparent.bgColour,
      padding: '16px',
    },
    '& .detailExpansionPanel-cus': {
      padding: '0 !important',
      border: 'none !important',
    },
    '& .detailExpansionPanel': {
      '& .detailExpansionPanelRow:nth-child(odd)': {
        '& .span1': {
          background: theme.palette.primary.bg4,
        },
        '& .span2': {
          background: theme.palette.primary.bg3,
        },
      },
      display: 'flex',
      flexDirection: 'column',
      // background: theme.palette.primary.bg2,
      padding: '30px 0px',
      borderRadius: '5px',

      border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
    },
    // "& .divData table tbody tr td:first-child":{
    //     background:"purple",
    // },
    '& table': {
      borderCollapse: 'unset',

      '& thead th > span': {
        fontSize: '14px',
        transform: 'translate(11px, 0px)',
        fontWeight: 'bold',
      },
      '& thead th > div p': {
        fontSize: '14px',
        transform: 'translate(11px, 0px)',
        fontWeight: 'bold',
      },
      '& thead th': {
        borderBottom: 0,
        position: 'relative',
      },
      // '& thead th:before':{
      //    content:"''",
      //    background:theme.palette.tableTbodyBg.background,
      //    width:"12px",
      //    height:"11px",
      //    backgroundRepeat:"no-repeat",
      //    position:"absolute",
      //    top: "50%",
      //    transform: "translate(0px, -50%)!important",
      //    left:"14px",
      // },
      '& tbody': {
        '& tr': {
          fontFamily: 'roboto!important',
        },
        '& td': {
          position: 'relative',
          border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
          lineHeight: 1.2,
          padding: '3px 10px 3px 17px!important',
          fontSize: '13px!important',
          fontWeight: '100!important',
          height: '57px',

          '&:hover': {
            '& .showInfoToolTip': {
              display: 'block',
              '&.noDetails': {
                display: 'flex',
              },
            },
            '& .arrowUp': {
              display: 'block',
            },
          },
          '& .showInfoToolTip': {
            top: '-100px',
            color: '#fff',
            right: 0,
            left: 152,
            width: 300,
            display: 'none',
            padding: '20px 15px',
            borderRadius: 6,
            zIndex: 999999,
            position: 'absolute',
            fontSize: '12px',
            marginBottom: 30,
            background: 'rgba(0,0,0,0.81)',
            boxShadow:
              '0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)',
            '&.systemToolTip': {
              top: -83,
            },
            '& .arrowUp': {
              left: -15,
              marginTop: -5,
              position: 'absolute',
              top: '50%',
              transform: 'rotate(270deg)',
              borderLeft: '10px solid transparent',
              display: 'block',
              borderRight: '10px solid transparent',
              borderBottom: '10px solid rgba(0,0,0,0.81)',
            },
            '& > div': {
              display: 'flex',
              alignItems: 'center',
              marginBottom: 5,
              justifyContent: 'space-between',
              '&.ispBorder': {
                borderBottom: '1px dashed #fff',
                paddingBottom: 5,
                marginBottom: 10,
              },
              '& > span': {
                minWidth: 120,
                fontSize: 14,
                fontWeight: 'bold',
              },
              '& div': {
                display: 'flex',
                alignItems: 'center',
                '& span': {
                  padding: '5px 10px',
                  borderRadius: 20,
                  fontWeight: 'bold',
                  fontSize: 14,
                  display: 'inline-block',
                  textAlign: 'left',
                },
                '& img': {
                  marginLeft: 10,
                },
              },
            },
            '& ol': {
              margin: 0,
              padding: '0 15px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#454545',
            },
            '@media (max-width:767px)': {
              width: '300px',
              left: 0,
              right: 0,
              top: '90%',
              '& .arrowUp': {
                transform: 'rotate(0deg)',
                top: -5,
                left: 20,
              },
            },
            '&.noDetails': {
              top: 0,
              bottom: 0,
              marginBottom: 0,
              padding: 0,
              justifyContent: 'center',
              '& > div': {
                justifyContent: 'center',
              },
            },
          },
        },
      },
      '& tfoot': {
        background: theme.palette.tableTbodyBg.color,
        '& svg': {
          fontSize: '1rem',
        },
        '& tr td': {
          borderBottomColor: 'transparent',
          paddingBottom: '20px!important',
          paddingRight: '23px!important',
        },
      },
    },
  },
  Active: {
    background: 'green',
    padding: 5,
    color: '#f5f5f5',
  },
  inActive: {
    background: 'red',
    padding: 5,
    color: '#f5f5f5',
  },
  Blocked: {
    background: 'red',
    padding: '5px 10px',
    color: '#f5f5f5',
  },
  Pending: {
    background: '#cfb70b',
    padding: '5px 10px',
    color: '#f5f5f5',
  },
  error: {
    borderBottom: '1px solid #e01100 !important',
  },
  pageLoader: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: '0',
    top: '0',
    background: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9,
  },
  Low: {
    background: '#777777',
    padding: '5px',
    color: '#f5f5f5',
  },
  Medium: {
    background: '#cfb70b',
    padding: '5px',
    color: '#f5f5f5',
  },
  High: {
    background: '#EF5350',
    padding: '5px',
    color: '#f5f5f5',
  },
  Critical: {
    background: '#F76397',
    padding: '5px',
    color: '#f5f5f5',
  },
  Notes: {
    background: '#7266BA',
    padding: '5px',
    color: '#f5f5f5',
  },
  Initiated: {
    background: '#f2c572',
    padding: '5px',
    color: '#f5f5f5',
  },
  InProgress: {
    background: '#a01497',
    padding: '5px',
    color: '#f5f5f5',
  },
  Completed: {
    background: '#3597dc',
    padding: '5px',
    color: '#f5f5f5',
  },
  Cancelled: {
    background: '#cc66ff',
    padding: '5px',
  },
  'Re-testing': {
    background: '#0066ff',
    padding: '5px',
    color: '#f5f5f5',
  },
  Reportsubmitted: {
    background: '#f69',
    padding: '5px',
    color: '#f5f5f5',
  },
  RiskAccepted: {
    background: '#804080',
    padding: '5px',
    color: '#f5f5f5',
  },
  'Fixed-PendingVerification': {
    background: '#b5b5b5',
    padding: '5px',
    color: '#f5f5f5',
  },
  Fixed: {
    background: '#81d742',
    padding: '5px',
    color: '#f5f5f5',
  },
  Open: {
    background: '#01d157',
    padding: '5px',
    color: '#f5f5f5',
  },
  Invalid: {
    background: '#ff71a6',
    padding: '5px',
    color: '#f5f5f5',
  },
  nowrapTh: {
    wordBreak: 'initial',
  },
  nowrapThWithIcon: {
    wordBreak: 'initial',
    display: 'block',
    alignItems: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '50px',
    paddingRight: 20,
    position: 'relative',
    '@media (min-width: 1919px)': {},
    '@media (min-width: 3799px)': {
      width: 100,
    },
    '@media (min-width: 5699px)': {
      width: 4150,
    },
    '@media (min-width: 7599px)': {
      width: 6000,
    },
    '& svg': {
      position: 'absolute',
      right: 0,
      top: 0,
    },
  },
  companyList: {
    position: 'relative',
    // '& .cardDiv':{
    //     backgroundColor:theme.palette.tableTbodyBg.color+"!important",
    // },
  },
  iconStyle: {
    '& table tbody tr td:first-child button  ': {
      //     fill: "red !important",
      border: '1px solid #02b758',
      borderRadius: '50%',
      padding: '0px',
    },
  },
  GeneralSet: {
    '& > div': {
      background: 'none',
      boxShadow: 'none',
    },
    '& > div > div > div > div': {
      borderRadius: '8px',
      marginTop: '1rem',
    },
  },

  releaseLink: {
    color: theme.palette.secondary.contrastText,
    fontWeight: '800',
    cursor: 'pointer',
    border: '1px solid #14A357',
    borderRadius: '20px',
    padding: '8px 15px',
  },

  activeButton: {
    width: 'auto',
    minWidth: 120,
    minHeight: 42,
    lineHeight: '42px',
    textAlign: 'center',
    padding: '0 12px',
    border: 0,
    color: '#fff',
    background: theme.palette.secondary.main,
    float: 'right',
    marginLeft: 15,
    marginBottom: 5,
    borderRadius: '20px !important',
    '&:hover': {
      background: theme.palette.secondary.main,
      opacity: 0.9,
    },
  },

  contentLoaderContainer: {
    width: '100%',
    boxShadow: `0 4px 10px ${theme.palette.primary.boxShadow}`,
    marginTop: 30,
  },
  searchHeader: {
    position: 'relative',
  },
  removePadding: {
    padding: '0 !important',
  },
  freezeFooter: {
    maxHeight: 'calc(100vh - 340px)',
    overflowY: 'auto',
    width: '100%',
    padding: '0 20px',
    boxSizing: 'border-box',
    '@media (max-width:767px)': {
      margin: '0',
      padding: '0 10px',
    },
  },
  whiteListed: {
    position: 'relative',
    '& > div > div:first-child': {
      // top:-50
    },
    '& > div > div + div': {
      overflowX: 'visible !important',
      '& > div > div': {
        overflowY: 'visible !important',
      },
    },
  },
  systemEventsTable: {
    '& table tbody td:nth-child(3)': {
      width: 400,
      minWidth: 400,
      maxWidth: 400,
    },
  },
  crashLogSet: {
    '& > div > div > div > div:nth-child(1)': {
      right: '0px',
    },
  },
  SmptSet: {
    '& > div > div > div > div:nth-child(1)': {
      right: '18px',
      top: '-110px',
    },
    '& > div > div > div > div:nth-child(2) > div > div': {
      borderRadius: '8px',
    },
    '& > div > div > div': {
      position: 'initial!important',
      boxShadow: '4px 4px 17px rgb(0 0 0 / 8%)!important',
    },
  },
  whiteListedIpTable: {
    '& table tbody tr td:first-child': {
      minWidth: 250,
      width: '250px !important',
      maxWidth: 250,
    },
    '& table thead tr th:first-child': {
      minWidth: 250,
      width: '250px !important',
      maxWidth: 250,
    },
    '& table tbody tr td:nth-child(2)': {
      minWidth: 400,
      width: '400px !important',
      maxWidth: 400,
    },
    '& table thead tr th:nth-child(2)': {
      minWidth: 400,
      width: '400px !important',
      maxWidth: 400,
    },
    '& table tbody tr td:last-child': {
      '& div': {
        justifyContent: 'center',
      },
    },
    '& table thead tr th:last-child': {
      '& svg': {
        display: 'none',
      },
    },
  },
  iconOpen: {
    transform: 'none !important',
  },
  mlscanHeaderRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    float: 'right',
    alignItems: 'end',
    position: 'relative',
    '& svg': {
      borderLeft: `1px solid ${theme.palette.tableBorderTransparent.color}`,
    },

    '& > div:first-child': {
      width: '83px',
      position: 'absolute',
      right: '3px',
      top: '60px',
      borderRadius: '20px!important',
      padding: '0px 6px',
      zIndex: '3',
      border: `1px solid ${theme.palette.tableBorderTransparent.color}`,
      '& > div': {
        // borderRight:'1px solid ' + theme.palette.tableBorderTransparent.color,
        // marginRight:"17px",
        padding: '4px 0px',
        fontSize: '10px',
        textAlign: 'center',
        paddingRight: '17px',
        '&:focus': {
          display: 'none',
        },
      },
      '&:before': {
        display: 'none',
      },
      '&:after': {
        display: 'none',
      },
    },
    '& > div + div': {
      position: 'static',
      // marginLeft: '20px'
    },
  },
  loginSessions: {
    position: 'relative',
    padding: '10px 20px 20px',
    backgroundColor: theme.palette.profileSectionSidebarContent.color,
    '& > button': {
      top: 22,
      borderRadius: 20,
      right: 25,
      // padding: '5px 20px',
      padding: '0 12px',
      minHeight: 42,
      background: '#01BD5A',
      width: 'auto',
      height: 'auto',
      position: 'absolute',
      border: 'none',
      '&:hover': {
        backgroundColor: `${theme.palette.actionBtnBorder.color}! important`,
      },
      '@media (max-width:767px)': {
        position: 'relative',
        top: 'unset',
        right: 0,
      },
    },
    '& .webBrowser': {
      display: 'flex',
      alignItems: 'center',
      '& .green': {
        display: 'inline-block',
        minWidth: 15,
        height: 15,
        borderRadius: '50%',
        marginRight: 5,
        background: '#189b54',
      },
      '& .red': {
        display: 'inline-block',
        minWidth: 15,
        height: 15,
        borderRadius: '50%',
        marginRight: 5,
        background: 'red',
      },
      '& svg': {
        minWidth: 30,
        height: 30,
        maxWidth: 30,
        fill: theme.palette.modalTextColor.color,
        marginRight: 5,
        marginTop: -10,
      },
    },
    '& .deviceType': {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        minWidth: 30,
        maxWidth: 30,
        height: 30,
        fill: theme.palette.modalTextColor.color,
        marginRight: 5,
      },
    },
  },
  licenseCopyDownloadBtn: {
    padding: '10px 30px',
    marginLeft: '10px',
    borderRadius: '20px!important',
    color: '#ffffff!important',
    background: '#08B565!important',
    fontSize: '12px',
  },
  defaultButton: {
    color: '#fff!important',
    background: `${theme.palette.defaultBtnShadow.background}!important`,
    '&:hover': {
      background: '#5e627b!important',
      color: '#1e1c1c!important',
      boxShadow: theme.palette.defaultBtnShadow.boxShadow,
    },
  },
  licenseUploadBtn: {
    padding: '10px 30px',
    marginLeft: '10px',
    marginTop: '10px',
    borderRadius: '30px',
    background: '#01BD5A',
    color: '#ffffff',
  },
  customModalWidth: {
    width: '100% !important',
  },
  mb5: {
    marginBottom: '5px !important',
  },
  publicKeyModel: {
    '& fieldset': {
      border: '1px solid #555 !important',
    },
    '& textarea': {
      maxHeight: '70px',
      marginBottom: '15px',
      border: '1px solid',
      borderRadius: '5px',
      padding: '10px',
    },
  },
  publicKeyModelText: {
    '& ::before': {
      display: 'none',
    },
  },
  loginSessionBg: {
    backgroundColor: theme.palette.profileSectionSidebarContent.color,
    padding: '0px 20px 30px',
    '& > div': {
      background: 'none',
      '& > div': {
        minHeight: '64px !important',
        marginTop: '0 !important',
        position: 'static !important',
        '& + div': {
          '& > div > div': {
            marginTop: '0 !important',
          },
        },
      },
    },
  },
  pageTitle: {
    marginRight: '15px',
    fontSize: '20px',
    color: theme.palette.modalTextColor.color,
  },
  goBackButton: {
    position: 'absolute',
    top: '14px',
    right: '22px',
  },
  activeSessionPadding: {
    padding: '0px',
  },
});
export default listTableStyle;
